import { api, apiRequest } from "./api";

export type StaffCommunicationMedium =
  | "whatsapp"
  | "email"
  | "sms"
  | "phone"
  | "push_notification"
  | "web_push_notification"
  | "slack";

export type StaffCommunicationStatus =
  | "pending"
  | "sent"
  | "failed"
  | "delivered"
  | "bounced";

export type StaffCommunicationProvider =
  | "onesignal"
  | "msg91"
  | "superfone"
  | "aisensy"
  | "slack";

export interface StaffCommunicationRecord {
  id: string;
  console_user: number;
  console_user_name: string;
  communication_medium: StaffCommunicationMedium;
  communication_provider: StaffCommunicationProvider;
  status: StaffCommunicationStatus;
  recipient: string;
  template_id: string;
  template_name: string;
  external_id: string;
  error_code: string;
  error_message: string;
  metadata: Record<string, unknown>;
  // Phase 3 new fields
  provider_response: Record<string, unknown> | null;
  http_status_code: number | null;
  response_time_ms: number | null;
  retry_count: number;
  parent_communication: string | null;
  created_at: string;
}

export interface StaffCommunicationListParams {
  console_user_id: string;
  medium?: StaffCommunicationMedium;
  provider?: StaffCommunicationProvider;
  status?: StaffCommunicationStatus;
  start_date?: string;
  end_date?: string;
  page?: number;
  page_size?: number;
}

export interface StaffCommunicationListResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: StaffCommunicationRecord[];
}

export interface StaffMediumByCount {
  communication_medium: StaffCommunicationMedium;
  count: number;
}

export interface StaffStatusByCount {
  status: StaffCommunicationStatus;
  count: number;
}

export interface StaffProviderByCount {
  communication_provider: StaffCommunicationProvider;
  count: number;
}

export interface StaffCommunicationStats {
  console_user_id: string;
  total: number;
  by_medium: StaffMediumByCount[];
  by_status: StaffStatusByCount[];
  by_provider: StaffProviderByCount[];
}

export const staffCommunicationsAPI = {
  listCommunications: (
    params: StaffCommunicationListParams
  ): Promise<StaffCommunicationListResponse> => {
    return apiRequest(() => api.get("/core/staff-communications/", { params }));
  },

  getStats: (consoleUserId: string): Promise<StaffCommunicationStats> => {
    return apiRequest(() =>
      api.get("/core/staff-communications/stats/", {
        params: { console_user_id: consoleUserId },
      })
    );
  },

  retryCommunication: (id: string): Promise<StaffCommunicationRecord> => {
    return apiRequest(() =>
      api.post(`/core/staff-communications/${id}/retry/`)
    );
  },
};
